// import React from "react";
import { GetStaticProps } from "next/types"
import nextI18nextConfig from "next-i18next.config"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Page } from "types/page"
import { PartnershipsHero } from "@cs/screens/partnerships"
import { Partnerships, TeamSection } from "@cs/lib/models/team.model"
import { SSRConfig } from "next-i18next"
import { ParsedUrlQuery } from "querystring"
import { loadTeams } from "@cs/lib/firebase/team/loadTeam"
import { TeamTab } from "@cs/screens/about"

export interface AboutProps extends SSRConfig {
  partnerSections: TeamSection[]
}

const PartnershipsPage: Page<AboutProps> = ({ partnerSections }) => (
  <main>
    <PartnershipsHero />
    <TeamTab teamSections={partnerSections} sectionType="partnership" />
  </main>
)

export default PartnershipsPage

export const getStaticProps: GetStaticProps<AboutProps, ParsedUrlQuery> = async ({ locale }) => {
  const partnerSections = await loadTeams<Partnerships>("partnerships", "partners")

  return {
    props: {
      partnerSections,
      ...(await serverSideTranslations(
        locale ?? "en",
        ["common", "footer", "nav", "partnerships", "about", "landing-page"],
        nextI18nextConfig,
      )),
    },
  }
}
